export class ContragentProject {
    contragentProjectId: number;
    contragentId: number;
    agreementId: number;
    projectName: string;
}